import { DelayedStartRecordingTriggerComponent } from './components/delayed-start-recording-trigger/delayed-start-recording-trigger.component';
import { RecordingCanvasComponent } from './components/recording-canvas/recording-canvas.component';
import { SourceSelectorComponent } from './components/source-selector/source-selector.component';
import { StartRecordingTriggerComponent } from './components/start-recording-trigger/start-recording-trigger.component';
import { StopRecordingTriggerComponent } from './components/stop-recording-trigger/stop-recording-trigger.component';
import { ToasterComponent } from './components/toaster/toaster.component';
import { Application } from './framework/application';
import { getBuildNumber } from './framework/utils/get-build-number.fn';
import { isProd } from './framework/utils/is-prod.fn';
import { sentryInit } from './framework/utils/sentry-init.fn';
import { PlModule } from './pl.module';
import { RecorderModule } from './recorder.module';

export class ScreenCorderApplication extends Application {
  constructor() {
    super('screencorder', {
      modules: [RecorderModule, PlModule],
      declarations: [
        StartRecordingTriggerComponent,
        RecordingCanvasComponent,
        StopRecordingTriggerComponent,
        SourceSelectorComponent,
        DelayedStartRecordingTriggerComponent,
        ToasterComponent,
      ],
    });
  }

  protected async onInit() {
    sentryInit(isProd(), getBuildNumber(), () => 0.1);
  }
}
